import { Empresa, Pessoa } from '@tivic-team/manager-ts/dist/grl';
import { Linha } from '@tivic-team/manager-ts/dist/mob/entities/linha/linha.entity';
import { ConcessaoVeiculo } from '@tivic-team/manager-ts/dist/mob/entities/concessao/concessao-veiculo.entity';
import { Agente }  from '@tivic-team/manager-ts/dist/mob/entities/agente.entity';
import { HorarioAfericao } from '@tivic-team/manager-ts/dist/mob/entities/horario/horario-afericao.entity';

export class HorarioAfericaoDTO{
    horarioAfericao: HorarioAfericao= void(0);
    concessionario: Pessoa = void(0);
    agente: Agente = void(0);
    linha: Linha = void(0);
    concessaoVeiculo: ConcessaoVeiculo = void(0);
    empresa: Empresa = void(0);

    constructor() {}
}